// import $ from 'jquery';
import PreferabliSTPApp from './stp.class';

'use strict';
(function ($) {

  if (!window.jQuery) {
    throw new Error("jQuery is required for PreferabliSTP plugin.");
  }

  function PreferabliSTP(element, options) {
    if (!element || !(element instanceof Element || (element instanceof jQuery && element[0] instanceof Element) || typeof element === 'string')) {
      throw 'A valid DOM element or selector is required to initialize Preferabli Similar Tasting Products plugin.';
    }

    if (!options || typeof options.integration_id === 'undefined') {
      throw 'integration_id is required for PreferabliSTP.';
    }

    if (typeof options.collection_id === 'undefined') {
      throw 'collection_id is required for PreferabliSTP.';
    }

    const el = element instanceof jQuery ? element[0] : 
               (typeof element === 'string' ? document.querySelector(element) : element);

    this.element = el;
    this.opts = $.extend(true, {
      lang: 'en',
      root: el,
    }, options);

    this._name = 'preferabliSTP';
    this._stp = null;

    this.init();
  }

  PreferabliSTP.prototype = {
      constructor: PreferabliSTP,
      init: function () {
        this._stp = new PreferabliSTPApp(this.element, {
          ...this.opts,
          element: this.element,
        });

        // Legacy aliases on global for direct access
        window.preferabliSTP = this._stp;
        window.WRLikeThatTryThis = this._stp;
        window.PreferabliLTTT = this._stp;
      },

      getProducts: function (params) {
        this._stp.getLTTT(params);
      }
  };

  $.fn.preferabliSTP = function (options) {
    const isCommand = typeof options === 'string';
    const args = Array.prototype.slice.call(arguments, 1);

    return this.each(function () {
      const $el = $(this);
      let instance = $el.data('preferabliSTP');

      if (isCommand) {
        if (instance && typeof instance[options] === 'function') {
          instance[options](...args);
        }
      } else {
        if (!instance) {
          const opts = $.extend(true, {}, options);
          instance = new PreferabliSTP(this, opts);
          $el.data('preferabliSTP', instance);
        }
      }
    });
  };

  // Aliases
  $.fn.preferabliSimilarTastingProducts = $.fn.preferabliSTP;
  $.fn.preferabliLTTT = $.fn.preferabliSTP;
  $.fn.wrLikeThatTryThis = $.fn.preferabliSTP;

})(window.jQuery);
